"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatValue = exports.getNotAvailableStats = void 0;
const constants_1 = require("../constants");
const number_1 = require("../number");
const getNotAvailableStats = (stats) => {
    const noSpins = (stats === null || stats === void 0 ? void 0 : stats.totalSpins) <= 0;
    const noBonusSpins = (stats === null || stats === void 0 ? void 0 : stats.raw.bonusTotalSpins) <= 0;
    const noRTP = (stats === null || stats === void 0 ? void 0 : stats.RTP) <= 0;
    const noHitRate = (stats === null || stats === void 0 ? void 0 : stats.wins.freq) <= 0;
    const noBestWin = (stats === null || stats === void 0 ? void 0 : stats.wins.best.RTP) <= 0;
    return {
        RTP: noSpins || noRTP,
        PL: noSpins,
        SRP: noSpins,
        hitRate: noSpins || noHitRate,
        bestWin: noSpins || noBestWin,
        bonusFreq: noSpins || noBonusSpins,
        avgBonus: noSpins || noBonusSpins,
        apinsAgo: noSpins || noBonusSpins,
        totalSpins: noSpins,
    };
};
exports.getNotAvailableStats = getNotAvailableStats;
const formatValue = (value, format = 'raw', currency) => {
    if (!value && value !== 0) {
        return '-';
    }
    const fractionDigits = constants_1.DEFAULT_PRECISION;
    switch (format) {
        case 'raw':
            return value.toString();
        case 'number':
            return Number(value).toLocaleString();
        case 'percent':
            return `${(0, number_1.toFixedWithoutZeros)(Number(value), fractionDigits)}%`;
        case 'times':
            return `${(0, number_1.toFixedWithoutZeros)(Number(value), fractionDigits)}x`;
        case 'times-percent':
            return (0, exports.formatValue)(Number(value) / constants_1.HUNDRED_PERCENT, 'times');
        case 'frequency':
            return `1/${(0, number_1.toFixedWithoutZeros)(1 / Number(value), fractionDigits)}`;
        case 'currency':
            return Intl.NumberFormat('en-US', {
                style: 'currency',
                currency,
            }).format(Number(value));
        case 'thousands':
            return Intl.NumberFormat('en-US').format(Number(value));
        default:
            throw new Error('Unexpected Stat value format');
    }
};
exports.formatValue = formatValue;
